/**
 * Preenche estrelas nos cards usando o cache local gerado a partir do BK Reviews.
 * Não chama a API no carregamento da loja.
 */
(function () {
  function renderRating(el, average, count) {
    const avg = Number(average) || 0;
    const qty = Number(count) || 0;
    const floor = Math.floor(avg);
    const decimal = avg - floor >= 0.7 ? 1 : avg - floor >= 0.3 ? 0.5 : 0;

    el.classList.remove('shir7-card-rating--pending');
    el.classList.toggle('bk-zero-reviews', qty === 0);

    el.innerHTML =
      '<div class="rating" role="img" aria-label="' +
      avg.toFixed(1) +
      ' de 5 estrelas, ' +
      qty +
      ' avaliações">' +
      '<span aria-hidden="true" class="rating-star" style="--rating: ' +
      floor +
      '; --rating-max: 5; --rating-decimal: ' +
      decimal +
      ';"></span></div>' +
      '<p class="rating-count caption"><span aria-hidden="true">(' +
      qty +
      ')</span></p>';
  }

  function hideDuplicateRatings() {
    document
      .querySelectorAll(
        '.product-card-wrapper .collection-star-section:not(.shir7-card-rating), .product-card-wrapper .bk-reviews:not(.shir7-card-rating)'
      )
      .forEach((el) => {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      });
  }

  function findCachedProduct(el) {
    const cache = window.Shir7ReviewsCache;
    if (!cache) return null;

    const id = (el.getAttribute('data-product-id') || '').trim();
    const handle = (el.getAttribute('data-product-handle') || '').trim();
    const cachedId = id || cache.handles?.[handle];

    return (cachedId && cache.products?.[cachedId]) || (handle && cache.products?.[cache.handles?.[handle]]) || null;
  }

  function loadRatings() {
    const pending = [...document.querySelectorAll('.shir7-card-rating--pending')];
    if (!pending.length) return;

    for (const el of pending) {
      const product = findCachedProduct(el);
      renderRating(el, product?.averageRating || 0, product?.reviewAmount || 0);
    }

    hideDuplicateRatings();
  }

  function scheduleLoad() {
    hideDuplicateRatings();
    loadRatings();
    setTimeout(hideDuplicateRatings, 500);
    setTimeout(hideDuplicateRatings, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLoad);
  } else {
    scheduleLoad();
  }

  document.addEventListener('shopify:section:load', scheduleLoad);

  if ('MutationObserver' in window) {
    new MutationObserver(hideDuplicateRatings).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
